export const FileMixUploadMixin = {
  methods: {
    handleChange(file, fileList) {
      this.$log.debug('handleChange', file.size)
      const size = process.env.VUE_APP_LIMIT_FILE_UPLOAD | 10
      const limit = file.size / 1024 / 1024 < size
      if (!limit) {
        this.showError(`El documento adjunto no puede exceder los ${size}MB`)
        fileList.pop()
        return false
      }
      if (!file.raw.length && !(file.raw.type === 'image/png' ||
        file.raw.type === 'image/jpeg' ||
        file.raw.type === 'image/jpg' ||
        file.raw.type === 'application/pdf' ||
        file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.raw.type === 'application/vnd.ms-excel' ||
        file.raw.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.raw.type === 'application/msword')) {
        this.showError(`Documento con extension no valida.`)
        fileList.pop()
        return false;
      }
      this.createBase64Image(file)
    },
    createBase64Image(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = {
          name: file.name,
          type: file.raw.type,
          content: e.target.result
        };
        this.model.documentos.push(fileData);
      };
      reader.readAsDataURL(file.raw);
    },
    handleRemove(file, fileList) {
      this.$log.debug('handleRemove', file.size)
      //TODO delete file from documentos
      this.model.documentos = []
    }
  }
}
